import * as React from 'react'
import { EmployeeDto } from '../pages/user/userTypes';
import { Loader } from './Loader';
import { getAccount } from '../pages/user/userApi';
import { observable } from 'mobx';
import { QuestionnaireDto } from '../pages/questionnaire/questionnaireTypes';
import { AnsweredQuestionnaireDto } from '../pages/answeredQuestionnaireTypes';
import { Page } from '../api/pageable';
import { QuestionCatalogueDto } from '../pages/questionCatalogue/qustionCatalogueTypes';

export function withEmployee(cb: (employee: EmployeeDto) => JSX.Element): JSX.Element {
  return (
    <Loader
      withT={cb}
      loadT={() => getAccount().then(account => observable(account))}
      key={'withAccount'}/>
  )
}

export function withQuestionnaire(loadFunction: () => Promise<QuestionnaireDto>,
                                  cb: (questionnaire: QuestionnaireDto) => JSX.Element): JSX.Element {
  return (
    <Loader
      withT={cb}
      loadT={() => loadFunction().then(questionnaire => observable(questionnaire))}
      key={'withQuestionnaire'}/>
  )
}

export function withQuestionnairePage(loadFunction: () => Promise<Page<QuestionnaireDto>>,
                                  key: string,
                                  cb: (questionnairesPage: Page<QuestionnaireDto>) => JSX.Element): JSX.Element {
  return (
    <Loader
      withT={cb}
      loadT={() => loadFunction().then(questionnairesPage => observable(questionnairesPage))}
      key={key}/>
  )
}

export function withAnsweredQuestionnaire(loadFunction: () => Promise<AnsweredQuestionnaireDto>,
                                          cb: (questionnaire: AnsweredQuestionnaireDto) => JSX.Element): JSX.Element {
  return (
    <Loader
      withT={cb}
      loadT={() => loadFunction().then(questionnaire => observable(questionnaire))}
      key={'withAnsweredQuestionnaire'}/>
  )
}

export function withAnsweredQuestionnairePage(loadFunction: () => Promise<Page<AnsweredQuestionnaireDto>>,
                                      key: string,
                                      cb: (questionnairesPage: Page<AnsweredQuestionnaireDto>) => JSX.Element): JSX.Element {
  return (
    <Loader
      withT={cb}
      loadT={() => loadFunction().then(questionnairesPage => observable(questionnairesPage))}
      key={key}/>
  )
}

export function withEmployeePage(loadFunction: () => Promise<Page<EmployeeDto>>,
                                              key: string,
                                              cb: (employeePage: Page<EmployeeDto>) => JSX.Element): JSX.Element {
  return (
    <Loader
      withT={cb}
      loadT={() => loadFunction().then(employeePage => observable(employeePage))}
      key={key}/>
  )
}

export function withQuestionCataloguePage(
  loadFunction: () => Promise<Page<QuestionCatalogueDto>>,
  key: string,
  cb: (cataloguePage: Page<QuestionCatalogueDto>) => JSX.Element
): JSX.Element {
      return (
        <Loader
          withT={cb}
          loadT={() => loadFunction().then(questionCataloguePage => observable(questionCataloguePage))}
          key={key}/>
      )
}
